import "../styles/questionformatFaq.css";
import { useEffect, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const emphasizedPhrase = "other manufacturers have not been concluded";

const renderFaqParagraph = (paragraph) => {
  if (!paragraph.includes(emphasizedPhrase)) {
    return paragraph;
  }

  const [before, after] = paragraph.split(emphasizedPhrase);

  return (
    <>
      {before}
      <span className="faqEmphasis">{emphasizedPhrase}</span>
      {after}
    </>
  );
};

const QuestionFormatFaq = (props) => {
  const [toggleState, setToggleState] = useState({});
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {}, [selectedValues]);

  const handleButtonClick = (faqId, faqValue) => {
    setToggleState((prevState) => ({
      ...prevState,
      [faqId]: !prevState[faqId],
    }));
    setSelectedValues((prevValues) => {
      if (toggleState[faqId]) {
        return prevValues.filter((value) => value !== faqValue);
      } else {
        return [...prevValues, faqValue];
      }
    });
  };

  return (
    <>
      <div className="">
        <div className="questionHeading mb20">{props.faqHeading}</div>

        <div className="questionsFormatFaqContainer">
          <div className="columnsContainer">
            {props.faqs && (
              <>
                <div className="column">
                  {props.faqs.slice(0, Math.ceil(props.faqs.length / 2)).map((faq) => (
                    <div key={faq.id} className="faqBtnContainer">
                      <div className={`faqBtn ${toggleState[faq.id] ? "faqBtn-inverted" : ""}`}>
                        <div className="faqLabel" onClick={() => handleButtonClick(faq.id, faq.value)}>
                          {faq.label}
                        </div>
                        {toggleState[faq.id] ? (
                          <FaMinus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        ) : (
                          <FaPlus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        )}
                      </div>
                      {toggleState[faq.id] && (
                        <div className="faqPanel">
                          <div>
                            {faq.value.split("\n").map((paragraph, index) => (
                              <p className="faqSpacer" key={index}>
                                {renderFaqParagraph(paragraph)}
                              </p>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="column">
                  {props.faqs.slice(Math.ceil(props.faqs.length / 2)).map((faq) => (
                    <div key={faq.id} className="faqBtnContainer">
                      <div className={`faqBtn ${toggleState[faq.id] ? "faqBtn-inverted" : ""}`}>
                        <div className="faqLabel" onClick={() => handleButtonClick(faq.id, faq.value)}>{faq.label}</div>
                        {toggleState[faq.id] ? (
                          <FaMinus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        ) : (
                          <FaPlus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        )}
                      </div>
                      {toggleState[faq.id] && (
                        <div className="faqPanel">
                          <div>
                            {faq.value.split("\n").map((paragraph, index) => (
                              <p className="faqSpacer" key={index}>
                                {renderFaqParagraph(paragraph)}
                              </p>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionFormatFaq;
